import { useLayoutEffect } from "react";

/**
 * FAZ-102 — HER SAYFA EN ÜSTTEN AÇILIR.
 *
 * Kullanıcı (2026-08-02): "bazı sayfalardan diğer sayfalara geçince, ilk
 * sayfada aşağıdaysak yeni açılan sayfada da bu aşağıda görünür. Bu olmasın,
 * her girilen sayfa en yukarıdan açılsın."
 *
 * NEDEN OLUYORDU
 * --------------
 * Kaydırılan şey `window` DEĞİL: kabuk `.layout-root`u `overflow: hidden`
 * yapıyor ve gerçek kaydırma kabı `<main class="layout-content">`. Rota
 * değişince React o `<main>`i SÖKMÜYOR — yalnız içindeki `children` değişiyor.
 * DOM düğümü aynı kaldığı için `scrollTop` da olduğu yerde kalıyor: uzun bir
 * listenin ortasından bir detaya geçince detay sayfası ortasından açılıyordu.
 *
 * Tarayıcının kendi kaydırma geri-yüklemesi (`history.scrollRestoration`) da
 * bu kabı bilmez — o yalnız belge kaydırmasını yönetir. React Router'ın
 * `ScrollRestoration`ı da aynı sebeple çözmez.
 *
 * NEDEN `useLayoutEffect`
 * -----------------------
 * Sıfırlama boyamadan ÖNCE olmalı. `useEffect` ile yazılsaydı yeni sayfa bir
 * kare boyunca eski kaydırma konumunda çizilir, sonra yukarı zıplardı — göz
 * bunu "sayfa oynadı" diye okur.
 *
 * NEDEN `pathname` (arama parametresi DEĞİL)
 * ------------------------------------------
 * `?sayfa=3` ya da `?kume=geciken` gibi değişimler AYNI sayfanın içindeki
 * durumdur; orada kaydırmayı sıfırlamak kullanıcıyı listenin başına atardı.
 * Sıfırlama yalnız gerçekten BAŞKA bir sayfaya geçilince.
 *
 * @param {React.RefObject<HTMLElement>} kapRef  overflow-y:auto olan kap
 * @param {string} pathname  useLocation().pathname
 */
export default function useTepeyeDon(kapRef, pathname) {
  useLayoutEffect(() => {
    const kap = kapRef && kapRef.current;
    if (kap && typeof kap.scrollTop === "number") kap.scrollTop = 0;
  }, [kapRef, pathname]);
}
